import React, { useState, useEffect, createRef, useMemo } from "react";
import { format } from "date-fns";

import location_icon from "../../../Assets/Icons/location_on.jpg";
import sub_location_icon from "../../../Assets/Icons/pin_drop.png";
import { Country } from "country-state-city";

import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import PeopleForm from "./PeopleForm";
import { LetteredAvatarImageUrl } from "../../components/common/userProfilePlaceholder";
import { PhoneNumberUtil } from "google-libphonenumber";
import { selectTranslations } from "../../config/i18n/slice";
import {
  AdminIcon,
  CloseIcon,
  LimitedAdminIcon,
  TechnicianIcon,
  ViewerIcon,
} from "../../../Assets/Icons/svg";
import ToolTip from "react-power-tooltip";
import { Resizable } from "re-resizable";
import useNewCancelModal from "../../../hooks/Messages/useNewCncelModal";
import { validateEmail } from "../../config/common/commonFunctions";
import { uploadFile, urlToFile } from "../../config/api/configApis";
import { getAllTeams } from "../../config/sharedApi/teamApis";
import { getActiveUsersByRole } from "../../config/sharedApi/peopleApis";
import { getAllParentLocations } from "../../config/sharedApi/locationApis";
import { getAllJobTitles } from "../../config/sharedApi/jobTitleApis";
import {
  updateUser,
  updateUserProfile,
  verifyPersonEmailAndPhone,
} from "../../config/api/peopleApis";
import vr from "../../../utilFunctions/validationRules";
const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};

const firstTabValidationFields = [
  "firstName","lastName","department","supervisor","role",
  "email","phone","whpw","whpd","jobTitle","workPermitNo",
  "hourRate","shifts","days","locations"
];
const secondTabValidationFields = ["emergencyPhone","address","identificationNo","childrenNo","passportNo","visaNo"];

function Edit({
  targetedData,
  targetedUserProfile,
  targetedUserProfileID,
  toggled,
  untoggle,
  setFilterOptions,
  setSearchTitle,
  setSortData,
  roleData,
  allIds,
}) {
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const [initChange, setInitChange] = useState(true);
  const [activePane, setActivePane] = useState(0);
  const [errorPane, setErrorPane] = useState({
    pane0: false,
    pane1: false,
  });

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const { setNewCancelModal, NewCancelModal } = useNewCancelModal();
  const [buttonStatus, setButtonStatus] = useState(0);
  const [isLoadingActive, activateLoading] = useState(false);
  const [cancelModal, toggleCancelModal] = useState(false);
  const [responseData, setResponseData] = useState({});

  const [fetchingLocations, setFetchingLocations] = useState(true);
  const [fetchingJobTitle, setFetchingJobTitle] = useState(true);
  const [fetchingTeams, setFetchingTeams] = useState(true);
  const [fetchingSupervisors, setFetchingSupervisors] = useState(true);
  const [fetchingCountries, setFetchingCountries] = useState(true);
  const [showCancleTooltip, setCancleTooltip] = useState(false);
  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const [personalImgId, setPersonalImgId] = useState();
  const [file, setFile] = useState(""); //
  const [imageSrc, setImageSrc] = useState("");

  const t = useSelector(selectTranslations);

  const { lenBetween, isPositiveNumber, isNumberInRange, isDateString } = vr;

  const addCustomYupMethods = (t) => {
    Yup.addMethod(Yup.string, 'phone', function (message = t?.people?.invalid_phone || "Invalid phone number") {
      return this.test('phone', message, function (value) {
        const { path, createError } = this;
        if (!value) return true;
        return isPhoneValid(value) || createError({ path, message });
      });
    });

    Yup.addMethod(Yup.string, 'lenBetween', function (min, max, message) {
      return this.test('lenBetween', message, function (value) {
        const { path, createError } = this;
        if (!value) return true;
        return lenBetween(value, min, max) || createError({ path, message });
      });
    });

    Yup.addMethod(Yup.number, 'positiveOrZero', function (message = t?.common?.must_be_positive || "Must be 0 or higher") {
      return this.test('positiveOrZero', message, function (value) {
        const { path, createError } = this;
        if (value == null) return true;
        return isPositiveNumber(Number(value)) || createError({ path, message });
      });
    });

    Yup.addMethod(Yup.number, 'inRange', function (min, max, message) {
      return this.test('inRange', message, function (value) {
        const { path, createError } = this;
        if (value == null) return true;
        return isNumberInRange(Number(value), min, max) || createError({ path, message });
      });
    });

    Yup.addMethod(Yup.string, 'validDate', function (message = t?.common?.invalid_date || "Invalid date") {
      return this.test('validDate', message, function (value) {
        const { path, createError } = this;
        if (!value) return true;
        return isDateString(value) || createError({ path, message });
      });
    });
  };

  const MSG = {
    required: t.common.required_field,
    whpdRange: t.people?.errors?.whpd_between || "Hours/day must be 0–24",
    whpwRange: t.people?.errors?.whpw_between || "Hours/week must be 0–168",
    positiveOrZero: t.common.must_be_positive || "Must be 0 or higher",
    invalidOption: t.common.invalid_option || "Invalid option",
    atLeastOneDay: t.people?.errors?.select_one_day || "Select at least one working day",
    atLeastOneShift: t.people?.errors?.select_one_shift || "Select at least one shift",
    oneLocation: t.people?.errors?.select_location || "Select at least one location",
    invalidPhone: t.people?.invalid_phone || "Invalid phone number",
    invalidDate: t.common.invalid_date || "Invalid date",
    minmax: (min, max) =>
        (t.common.minmax_chars || "Must be {min}–{max} characters")
            .replace("{min}", String(min))
            .replace("{max}", String(max)),
  };

  const {
    PersonValidationSchema,
    PersonTechnicianValidationSchema,
    PersonRequesterValidationSchema,
    PersonLimitedValidationSchema,
  } = useMemo(() => {
    addCustomYupMethods(t);

    const Base = Yup.object().shape({
      firstName: Yup.string().required(MSG.required).lenBetween(3, 100, MSG.minmax(3, 100)),
      lastName:  Yup.string().required(MSG.required).lenBetween(3, 100, MSG.minmax(3, 100)),
      role: Yup.string().required(MSG.required),
      email: Yup.string().email(t.people.invalid_email).required(MSG.required),
      phone: Yup.string().required(MSG.required).phone(MSG.invalidPhone),
      whpd: Yup.number().inRange(0, 24, MSG.whpdRange).required(MSG.required),
      whpw: Yup.number().inRange(0, 168, MSG.whpwRange).required(MSG.required),
      hourRate: Yup.number().positiveOrZero(MSG.positiveOrZero).required(MSG.required),
      address: Yup.string().required(MSG.required).lenBetween(3, 255, MSG.minmax(3, 255)),
      martialStatus: Yup.string().oneOf(['single','married'], MSG.invalidOption).required(MSG.required),
      educationLevel: Yup.string().oneOf(
          ['highSchoolDegree','diplomaDegree','bachelorsDegree','mastersDegree','doctorateDegree','other'],
          MSG.invalidOption
      ).required(MSG.required),
      identificationNo: Yup.string().required(MSG.required).lenBetween(3, 50, MSG.minmax(3, 50)),
      gender: Yup.string().oneOf(['male','female'], MSG.invalidOption).required(MSG.required),
      childrenNo: Yup.number().positiveOrZero(MSG.positiveOrZero).required(MSG.required),

      emergencyName: Yup.string().nullable(),
      emergencyPhone: Yup.string().nullable().phone(MSG.invalidPhone),

      fieldOfStudy: Yup.string().nullable().lenBetween(1, 100, MSG.minmax(1, 100)),
      nationality: Yup.string().nullable().lenBetween(1, 100, MSG.minmax(1, 100)),
      passportNo: Yup.string().nullable().lenBetween(3, 50, MSG.minmax(3, 50)),

      dob: Yup.string().nullable().validDate(MSG.invalidDate),
      cob: Yup.string().nullable(),
      visaNo: Yup.string().nullable().lenBetween(3, 50, MSG.minmax(3, 50)),
      workPermitNo: Yup.string().nullable().lenBetween(3, 50, MSG.minmax(3, 50)),
      visaExpireDate: Yup.string().nullable().validDate(MSG.invalidDate),
      registrationNo: Yup.number().nullable().positiveOrZero(MSG.positiveOrZero),
      badgeId: Yup.string().nullable(),
      department: Yup.string().nullable().lenBetween(3, 100, MSG.minmax(3, 100)),

      contractStart: Yup.string().nullable().validDate(MSG.invalidDate),
      contractEnd: Yup.string().nullable().validDate(MSG.invalidDate),

      shifts: Yup.object().shape({
        shiftA: Yup.boolean().required(),
        shiftB: Yup.boolean().required(),
        shiftC: Yup.boolean().required(),
      }).test("at-least-one-true", MSG.atLeastOneShift, v => v && (v.shiftA || v.shiftB || v.shiftC)),

      days: Yup.object().shape({
        sat: Yup.boolean().required(),
        sun: Yup.boolean().required(),
        mon: Yup.boolean().required(),
        tue: Yup.boolean().required(),
        wed: Yup.boolean().required(),
        thu: Yup.boolean().required(),
        fri: Yup.boolean().required(),
      }).test("at-least-one-true", MSG.atLeastOneDay,
          v => v && (v.sat||v.sun||v.mon||v.tue||v.wed||v.thu||v.fri)
      ),

      locations: Yup.array().of(Yup.number()).min(1, MSG.oneLocation).required(MSG.oneLocation),
    });

    return {
      PersonValidationSchema: Base,
      PersonLimitedValidationSchema: Base.shape({
        supervisor: Yup.string().required(MSG.required),
      }),
      PersonTechnicianValidationSchema: Base.shape({
        supervisor: Yup.string().required(MSG.required),
      }),
      PersonRequesterValidationSchema: Yup.object().shape({
        role: Yup.string().required(MSG.required),
        locations: Yup.array().of(Yup.number()).min(1, MSG.oneLocation).required(MSG.oneLocation),
        firstName: Yup.string().required(MSG.required).lenBetween(3, 100, MSG.minmax(3, 100)),
        lastName:  Yup.string().required(MSG.required).lenBetween(3, 100, MSG.minmax(3, 100)),
        phone: Yup.string().required(MSG.required).phone(MSG.invalidPhone),
        address: Yup.string().required(MSG.required).lenBetween(3, 255, MSG.minmax(3, 255)),
        martialStatus: Yup.string().oneOf(['single','married'], MSG.invalidOption).required(MSG.required),
        identificationNo: Yup.string().required(MSG.required).lenBetween(3, 50, MSG.minmax(3, 50)),
        gender: Yup.string().oneOf(['male','female'], MSG.invalidOption).required(MSG.required),
        whpd: Yup.number().nullable().positiveOrZero(MSG.positiveOrZero),
        whpw: Yup.number().nullable().inRange(0, 168, MSG.whpwRange),
        hourRate: Yup.number().nullable().positiveOrZero(MSG.positiveOrZero),
        email: Yup.string().nullable().email(t.people.invalid_email),
        educationLevel: Yup.string().nullable().oneOf(
            ['highSchoolDegree','diplomaDegree','bachelorsDegree','mastersDegree','doctorateDegree','other']
        ),
        childrenNo: Yup.number().nullable().positiveOrZero(),
        emergencyName: Yup.string().nullable(),
        emergencyPhone: Yup.string().nullable().phone(),
        fieldOfStudy: Yup.string().nullable(),
        nationality: Yup.string().nullable(),
        passportNo: Yup.string().nullable(),
        dob: Yup.string().nullable().validDate(MSG.invalidDate),
        cob: Yup.string().nullable(),
        visaNo: Yup.string().nullable(),
        workPermitNo: Yup.string().nullable(),
        visaExpireDate: Yup.string().nullable().validDate(MSG.invalidDate),
        registrationNo: Yup.number().nullable().positiveOrZero(),
        badgeId: Yup.string().nullable(),
        department: Yup.string().nullable(),
        contractStart: Yup.string().nullable().validDate(MSG.invalidDate),
        contractEnd: Yup.string().nullable().validDate(MSG.invalidDate),
        shifts: Yup.object({ shiftA: Yup.boolean().required(), shiftB: Yup.boolean().required(), shiftC: Yup.boolean().required() }).nullable(),
        days: Yup.object({ sat:Yup.boolean().required(), sun:Yup.boolean().required(), mon:Yup.boolean().required(), tue:Yup.boolean().required(), wed:Yup.boolean().required(), thu:Yup.boolean().required(), fri:Yup.boolean().required() }).nullable(),
      }),
    };
  }, [t]);

  const [options, setOptions] = useState({
    locations: {
      initOptions: [],
      options: [],
    },
    roles: [
      {
        key: 0,
        value: 5,
        text: t.people.add_modal.admin,
        icon: <AdminIcon />,
        description: t.people.add_modal.admin_description,
      },

      {
        key: 2,
        value: 9,
        text: t.people.add_modal.limited_admin,
        icon: <LimitedAdminIcon />,
        description: t.people.add_modal.limited_admin_description,
      },
      {
        key: 1,
        value: 8,
        text: t.people.add_modal.technician,
        icon: <TechnicianIcon />,
        description: t.people.add_modal.user_description,
      },

      {
        key: 3,
        value: 3,
        text: t.people.add_modal.viewer,
        icon: <ViewerIcon />,
        description: t.people.add_modal.viewer_description,
      },
    ],
    martialStatus: [
      {
        key: 0,
        value: "single",
        text: t.people.personal_info_form.martial_option.single,
      },

      {
        key: 1,
        value: "married",
        text: t.people.personal_info_form.martial_option.married,
      },
    ],

    userRole: [
      {
        key: 5,
        value: 5,
        text: t.people.add_modal.admin,
      },

      {
        key: 9,
        value: 9,
        text: t.people.add_modal.limited_admin,
      },
      {
        key: 8,
        value: 8,
        text: t.people.add_modal.technician,
      },
      {
        key: 3,
        value: 3,
        text: t.people.add_modal.viewer,
      },
      {
        key: 6,
        value: 6,
        text: t.people.add_modal.requester,
      },
    ],

    limitedRoles: [
      {
        key: 9,
        value: 9,
        text: t.people.add_modal.limited_admin,
      },
      {
        key: 8,
        value: 8,
        text: t.people.add_modal.technician,
      },
      {
        key: 3,
        value: 3,
        text: t.people.add_modal.viewer,
      },
      {
        key: 6,
        value: 6,
        text: t.people.add_modal.requester,
      },
    ],

    childrenNumber: [
      {
        key: 0,
        value: 0,
        text: "0",
      },

      {
        key: 1,
        value: 1,
        text: "1",
      },
      {
        key: 2,
        value: 2,
        text: "2",
      },
      {
        key: 3,
        value: 3,
        text: "3",
      },
      {
        key: 4,
        value: 4,
        text: "4",
      },
      {
        key: 5,
        value: 5,
        text: "5",
      },
      {
        key: 6,
        value: 6,
        text: "6",
      },
      {
        key: 7,
        value: 7,
        text: "7",
      },
    ],

    studyFiled: [
      {
        key: 0,
        value: "Agriculture and Forestry",
        text: t.people.studyField.agriculture,
      },

      {
        key: 1,
        value: "Architecture and Urban Planning",
        text: t.people.studyField.agricultureUrban,
      },
      {
        key: 2,
        value: "Arts and Humanities",
        text: t.people.studyField.arts,
      },
      {
        key: 3,
        value: "Astronomy and Astrophysics",
        text: t.people.studyField.astronomy,
      },
      {
        key: 4,
        value: "Business and Economics",
        text: t.people.studyField.economics,
      },
      {
        key: 5,
        value: "Communication and Media Studies",
        text: t.people.studyField.mediaStudy,
      },
      {
        key: 6,
        value: "Computer Science and Information Technology",
        text: t.people.studyField.computerScience,
      },
      {
        key: 7,
        value: "Cultural Studies",
        text: t.people.studyField.cultural,
      },
      {
        key: 8,
        value: "Education",
        text: t.people.studyField.education,
      },
      {
        key: 9,
        value: "Engineering and Technology",
        text: t.people.studyField.engineering,
      },
      {
        key: 10,
        value: "Environmental Science",
        text: t.people.studyField.environmental,
      },
      {
        key: 11,
        value: "Fine Arts and Design",
        text: t.people.studyField.fine_arts,
      },
      {
        key: 12,
        value: "Geology and Earth Sciences",
        text: t.people.studyField.geology,
      },
      {
        key: 13,
        value: "Health and Medicine",
        text: t.people.studyField.health,
      },
      {
        key: 14,
        value: "Hospitality and Tourism",
        text: t.people.studyField.hospitality,
      },
      {
        key: 15,
        value: "Law and Legal Studies",
        text: t.people.studyField.law,
      },
      {
        key: 16,
        value: "Library and Information Science",
        text: t.people.studyField.library,
      },
      {
        key: 17,
        value: "Linguistics",
        text: t.people.studyField.linguistics,
      },
      {
        key: 18,
        value: "Mathematics and Statistics",
        text: t.people.studyField.mathematics,
      },
      {
        key: 19,
        value: "Natural Sciences",
        text: t.people.studyField.naturalSciences,
      },
      {
        key: 20,
        value: "Performing Arts",
        text: t.people.studyField.performingArts,
      },
      {
        key: 21,
        value: "Philosophy",
        text: t.people.studyField.philosophy,
      },
      {
        key: 22,
        value: "Physical Education and Sports Science",
        text: t.people.studyField.physicalEducation,
      },
      {
        key: 23,
        value: "Political Science",
        text: t.people.studyField.politicalScience,
      },
      {
        key: 24,
        value: "Psychology",
        text: t.people.studyField.psychology,
      },
      {
        key: 25,
        value: "Public Administration",
        text: t.people.studyField.publicAdministration,
      },
      {
        key: 26,
        value: "Religious Studies",
        text: t.people.studyField.religiousStudies,
      },
      {
        key: 27,
        value: "Social Sciences",
        text: t.people.studyField.socialSciences,
      },
      {
        key: 28,
        value: "Sociology",
        text: t.people.studyField.sociology,
      },
    ],

    educationLevel: [
      {
        key: 0,
        value: "highSchoolDegree",
        text: t.people.personal_info_form.education_options.high_school,
      },
      {
        key: 1,
        value: "diplomaDegree",
        text: t.people.personal_info_form.education_options.diploma,
      },
      {
        key: 2,
        value: "bachelorsDegree",
        text: t.people.personal_info_form.education_options.bachelors,
      },
      {
        key: 3,
        value: "mastersDegree",
        text: t.people.personal_info_form.education_options.masters,
      },
      {
        key: 4,
        value: "doctorateDegree",
        text: t.people.personal_info_form.education_options.doctorate,
      },
      {
        key: 5,
        value: "other",
        text: t.people.personal_info_form.education_options.other,
      },
    ],
    countries: [],

    gender: [
      {
        key: 0,
        value: "male",
        text: t.people.personal_info_form.gender_options.gender_male,
      },

      {
        key: 1,
        value: "female",
        text: t.people.personal_info_form.gender_options.gender_female,
      },
    ],

    users: [],
    teams: [],
    jobTitle: "",
  });

  const [data, setData] = useState({
    locations: [],
    selectedLocation: [],
    teams: [],
    hourRate: "",
    whpd: "",
    whpw: "",
    department: "",
    contractStart: "",
    contractEnd: "",
    shifts: {
      shiftA: false,
      shiftB: false,
      shiftC: false,
    },
    days: {
      sat: false,
      sun: false,
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
    },
    firstName: "",
    lastName: "",
    username: "",
    address: "",
    email: "",
    countryCode: "962",
    phone: "",
    martialStatus: "single",
    emergencyName: "",
    emergencyCountryCode: "962",
    emergencyPhone: "",
    educationLevel: "highSchoolDegree",
    fieldOfStudy: "",
    nationality: "",
    identificationNo: "",
    passportNo: "",
    gender: "male",
    dob: "",
    cob: "",
    childrenNo: "",
    visaNo: "",
    workPermitNo: "",
    visaExpireDate: "",
    supervisor: "",
    jobTitle: "",
    role: "",
    registrationNo: "",
    badgeId: "",
  });

  const [validation, setValidation] = useState({
    locations: {
      error: false,
      pattern: (locations) => locations.length > 0 && locations != "",
      skipped: false,
      message: t.common.required_field,
    },
    firstName: {
      error: false,
      pattern: (firstName) => firstName != "",
      skipped: false,
      message: t.common.required_field,
    },
    lastName: {
      error: false,
      pattern: (lastName) => lastName != "",
      skipped: false,
      message: t.common.required_field,
    },

    email: {
      error: false,
      pattern: (email) => validateEmail(email),
      skipped: false,
      message: t.people.invalid_email,
    },

    phone: {
      error: false,
      pattern: (phone) => phone != "",
      skipped: false,
      message: t.common.required_field,
    },

    jobTitle: {
      error: false,
      pattern: (title) => title != "",
      skipped: false,
      message: t.common.required_field,
    },

    shifts: {
      error: false,
      pattern: (shifts) => shifts.some((el) => el != false),
      skipped: false,
      message: t.common.required_field,
    },

    days: {
      error: false,
      pattern: (days) => days.some((el) => el != false),
      skipped: false,
      message: t.common.required_field,
    },
    hourRate: {
      error: false,
      pattern: (hourRate) => hourRate != "",
      skipped: false,
      message: t.common.required_field,
    },
  });

  const [validForm, setValidForm] = useState(false);

  const [attachments, setAttachments] = useState({
    contractCopy: null,
    personalPicture: null,
    passportCopy: null,
    idCopyFront: null,
    visaCopy: null,
    covidCopy: [],
  });

  const resetForm = () => {
    setData({
      locations: [],
      selectedLocation: [],
      teams: [],
      hourRate: "",
      whpd: "",
      whpw: "",
      department: "",
      contractStart: "",
      contractEnd: "",
      shifts: {
        shiftA: false,
        shiftB: false,
        shiftC: false,
      },
      days: {
        sat: false,
        sun: false,
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
      },
      firstName: "",
      lastName: "",
      username: "",
      address: "",
      email: "",
      countryCode: "962",
      phone: "",
      martialStatus: "single",
      emergencyName: "",
      emergencyCountryCode: "962",
      emergencyPhone: "",
      educationLevel: "highSchoolDegree",
      fieldOfStudy: "",
      nationality: "",
      identificationNo: "",
      passportNo: "",
      gender: "male",
      dob: "",
      cob: "",
      childrenNo: "",
      visaNo: "",
      workPermitNo: "",
      visaExpireDate: "",
      supervisor: "",
      jobTitle: "",
      role: "",
      registrationNo: "",
      badgeId: "",
    });
    setModalWidth(Math.max(window.innerWidth / 2, 514));

    setAttachments({
      contractCopy: null,
      personalPicture: null,
      passportCopy: null,
      idCopyFront: null,
      visaCopy: null,
      covidCopy: [],
    });
    setFile("");
    setImageSrc("");
    setPersonalImgId(null);
    setActivePane(0);

    setValidation({
      locations: {
        error: false,
        pattern: (locations) => locations.length > 0 && locations != "",
        skipped: false,
        message: t.common.required_field,
      },
      firstName: {
        error: false,
        pattern: (firstName) => firstName != "",
        skipped: false,
        message: t.common.required_field,
      },
      lastName: {
        error: false,
        pattern: (lastName) => lastName != "",
        skipped: false,
        message: t.common.required_field,
      },

      email: {
        error: false,
        pattern: (email) => validateEmail(email),
        skipped: false,
        message: t.people.invalid_email,
      },

      phone: {
        error: false,
        pattern: (phone) => phone != "",
        skipped: false,
        message: t.common.required_field,
      },

      shifts: {
        error: false,
        pattern: (shifts) => shifts.some((el) => el != false),
        skipped: false,
        message: t.common.required_field,
      },

      days: {
        error: false,
        pattern: (days) => days.some((el) => el != false),
        skipped: false,
        message: t.common.required_field,
      },
      hourRate: {
        error: false,
        pattern: (hourRate) => hourRate != "",
        skipped: false,
        message: t.common.required_field,
      },
    });

    setErrorPane({
      pane0: false,
      pane1: false,
    });

    setFetchingCountries(true);
    setFetchingLocations(true);
    setFetchingJobTitle(true);
    setFetchingSupervisors(true);
    setInitChange(false);
    setFetchingTeams(true);
  };

  useEffect(() => {
    if (toggled) {
      fetchOptions();

      if (targetedData && targetedUserProfile && targetedUserProfileID) {
        setData({
          userId: targetedData?.id,
          profileId: targetedUserProfileID,
          hourRate: targetedUserProfile?.hourRate || "",
          whpd: targetedUserProfile?.whpd ? targetedUserProfile?.whpd : "",
          whpw: targetedUserProfile?.whpw ? targetedUserProfile?.whpw : "",
          department: targetedUserProfile?.department || "",
          contractStart: targetedUserProfile?.contractStart
            ? format(new Date(targetedUserProfile.contractStart), "yyyy-MM-dd")
            : "",
          contractEnd: targetedUserProfile?.contractEnd
            ? format(new Date(targetedUserProfile.contractEnd), "yyyy-MM-dd")
            : "",
          shifts: {
            shiftA: targetedUserProfile?.shifts?.shiftA || false,
            shiftB: targetedUserProfile?.shifts?.shiftB || false,
            shiftC: targetedUserProfile?.shifts?.shiftC || false,
          },
          days: {
            sat: targetedUserProfile?.days?.sat || false,
            sun: targetedUserProfile?.days?.sun || false,
            mon: targetedUserProfile?.days?.mon || false,
            tue: targetedUserProfile?.days?.tue || false,
            wed: targetedUserProfile?.days?.wed || false,
            thu: targetedUserProfile?.days?.thu || false,
            fri: targetedUserProfile?.days?.fri || false,
          },
          firstName: targetedData?.firstName ? targetedData?.firstName : "",
          lastName: targetedData?.lastName ? targetedData?.lastName : "",

          address: targetedUserProfile?.address
            ? targetedUserProfile?.address
            : "",
          email: targetedData?.email ? targetedData?.email : "",
          countryCode: targetedUserProfile?.phone
            ? String(targetedUserProfile?.phone).slice(0, 3)
            : "",

          phone: targetedUserProfile?.phone
            ? `+${targetedUserProfile?.phone}`
            : "",
          martialStatus: targetedUserProfile?.martialStatus
            ? targetedUserProfile?.martialStatus
            : "single",
          emergencyName: targetedUserProfile?.emergencyName
            ? targetedUserProfile?.emergencyName
            : "",
          emergencyCountryCode: targetedUserProfile?.emergencyPhone
            ? String(targetedUserProfile?.emergencyPhone).slice(0, 3)
            : "",
          emergencyPhone: targetedUserProfile?.emergencyPhone || "",
          educationLevel: targetedUserProfile?.educationLevel
            ? targetedUserProfile?.educationLevel
            : "highSchoolDegree",
          fieldOfStudy: targetedUserProfile?.fieldOfStudy
            ? targetedUserProfile?.fieldOfStudy
            : "",
          identificationNo: targetedUserProfile?.identificationNo
            ? targetedUserProfile?.identificationNo
            : "",
          passportNo: targetedUserProfile?.passportNo
            ? targetedUserProfile?.passportNo
            : "",
          gender: targetedUserProfile?.gender
            ? targetedUserProfile?.gender
            : "male",
          dob: targetedUserProfile?.dob ? moment(targetedUserProfile.dob) : "",
          childrenNo: targetedUserProfile?.childrenNo
            ? targetedUserProfile?.childrenNo
            : "",
          visaNo: targetedUserProfile?.visaNo
            ? targetedUserProfile?.visaNo
            : "",
          workPermitNo: targetedUserProfile?.workPermitNo,
          visaExpireDate: targetedUserProfile?.visaExpireDate
            ? moment(targetedUserProfile?.visaExpireDate)
            : "",

          jobTitle: targetedUserProfile?.job?.data?.id || "",
          role: targetedData?.role?.id ? targetedData?.role?.id : "",
          registrationNo: targetedUserProfile?.registrationNo
            ? targetedUserProfile?.registrationNo
            : "",
          badgeId: targetedUserProfile?.badgeId
            ? targetedUserProfile?.badgeId
            : "",
          supervisor: targetedData?.supervisor?.id
            ? targetedData?.supervisor?.id
            : "",
          teams: targetedData?.teams?.map((team) => team.id),
          nationality: targetedUserProfile?.nationality
            ? targetedUserProfile?.nationality
            : "",
          cob: targetedUserProfile?.cob ? targetedUserProfile?.cob : "",

          selectedLocation:
            targetedData?.locations.length > 0
              ? targetedData?.locations?.map((loc) => loc.id)
              : [],
        });

        setPersonalImgId(targetedData?.profileImage?.id);

        setAttachments({
          contractCopy: targetedUserProfile?.contractCopy?.data
            ? {
                id: targetedUserProfile?.contractCopy?.data?.id,
                file: urlToFile(
                  targetedUserProfile?.contractCopy?.data?.attributes?.url,
                  targetedUserProfile?.contractCopy?.data?.attributes?.name
                ),

                name: targetedUserProfile?.contractCopy?.data?.attributes.name,
                type: targetedUserProfile?.contractCopy?.data?.attributes.mime,
                cancelPopup: false,
                isChanged: false,
              }
            : null,
          personalPicture: targetedData?.profileImage?.id
            ? {
                id: targetedData?.profileImage?.id,
                url: targetedData?.profileImage?.url,
                file: urlToFile(
                  targetedData?.profileImage?.url,
                  targetedData?.profileImage?.name
                ),
                name: targetedData?.profileImage?.name,
                type: targetedData?.profileImage?.mime,
                cancelPopup: false,
                isChanged: false,
              }
            : null,
          passportCopy: targetedUserProfile?.passportCopy?.data
            ? {
                id: targetedUserProfile?.passportCopy?.data?.id,
                file: urlToFile(
                  targetedUserProfile?.passportCopy?.data?.attributes?.url,
                  targetedUserProfile?.passportCopy?.data?.attributes?.name
                ),
                name: targetedUserProfile?.passportCopy?.data?.attributes.name,
                type: targetedUserProfile?.passportCopy?.data?.attributes.mime,
                cancelPopup: false,
                isChanged: false,
              }
            : null,
          idCopyFront: targetedUserProfile?.idCopyFront?.data
            ? {
                id: targetedUserProfile?.idCopyFront?.data?.id,
                file: urlToFile(
                  targetedUserProfile?.idCopyFront?.data?.attributes?.url,
                  targetedUserProfile?.idCopyFront?.data?.attributes?.name
                ),
                name: targetedUserProfile?.idCopyFront?.data?.attributes.name,
                type: targetedUserProfile?.idCopyFront?.data?.attributes.mime,
                cancelPopup: false,
                isChanged: false,
              }
            : null,
          visaCopy: targetedUserProfile?.visaCopy?.data
            ? {
                id: targetedUserProfile?.visaCopy?.data?.id,
                file: urlToFile(
                  targetedUserProfile?.visaCopy?.data?.attributes?.url,
                  targetedUserProfile?.visaCopy?.data?.attributes?.name
                ),
                name: targetedUserProfile?.visaCopy?.data?.attributes.name,
                type: targetedUserProfile?.visaCopy?.data?.attributes.mime,
                cancelPopup: false,
                isChanged: false,
              }
            : null,
          covidCopy:
            targetedUserProfile?.covidCopy?.data &&
            targetedUserProfile?.covidCopy?.data?.length
              ? targetedUserProfile?.covidCopy?.data?.map((one) => {
                  return {
                    id: one?.id,
                    file: urlToFile(
                      one?.attributes?.url,
                      one?.attributes?.name
                    ),
                    name: one?.attributes?.name,
                    type: one?.attributes?.mime,
                    cancelPopup: false,
                    isChanged: false,
                  };
                })
              : [],
        });
      }
      // }
    }
  }, [toggled, targetedData, targetedUserProfile]);

  const fetchOptions = async () => {
    let rolesArray = [];

    switch (targetedData?.role?.id) {
      case 8:
        rolesArray = ["super_admin", "user"];
        break;
      case 9:
        rolesArray = ["super_admin", "limited_admin", "admin"];
        break;
      default:
        rolesArray = ["super_admin", "admin"];
    }

    const [teams, users, locations, countries, jobTitle] = await Promise.all([
      getAllTeams(
        organisationId,
        "",
        1,
        99999,
        [],
        [],
        [],
        !(roleData == "super_admin")
          ? targetedData?.locations?.map((loc) => loc.id)
          : targetedData?.locations?.map((loc) => loc.id) || []
      ),
      getActiveUsersByRole(
        rolesArray,
        organisationId,
        !(roleData == "super_admin")
          ? targetedData?.locations?.map((loc) => loc.id)
          : targetedData?.locations?.map((loc) => loc.id) || [],
        true
      ),
      getAllParentLocations(
        organisationId,
        "",
        1,
        99999,
        [],
        [],
        [],
        ["name:asc"]
      ),
      Country.getAllCountries(),
      getAllJobTitles(organisationId, "", 1, 99999),
    ]);

    let teams_options = [];
    if (teams.response) {
      teams_options = teams.response.map((el) => {
        const the_image = LetteredAvatarImageUrl(el.attributes.name);

        return {
          key: el.id,
          value: el.id,
          text: el.attributes.name,
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });

      setFetchingTeams(false);
    }

    let users_options = [];
    if (users.data) {
      users_options = users.data.map((el) => {
        const the_image = el.profileImage?.url
          ? el.profileImage?.url
          : LetteredAvatarImageUrl(el?.firstName + " " + el.lastName);
        return {
          key: el.id,
          value: el.id,
          text: `${el.firstName} ${el.lastName ? el.lastName : ""}`,
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });

      setFetchingSupervisors(false);
    }

    let parentOptions = [];
    let subOptions = [];
    let the_options = [];
    let all_options = [];
    if (locations?.response?.length > 0) {
      locations.response.forEach((el) => {
        if (!(roleData === "super_admin")) {
          if (allIds?.includes(el.id)) {
            parentOptions.push({
              key: el.id,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
              disabled: false,
            });

            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                if (allIds.includes(subEl.id)) {
                  subOptions.push({
                    key: subEl.id,
                    value: subEl.id,
                    text: subEl.attributes.name,
                    image: { src: sub_location_icon },
                    className: "sub-location-dropdown-option",
                    parentId: el.id,
                  });
                }
              });
            }
          } else {
            const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
              (subEl) => allIds?.includes(subEl.id)
            );

            if (hasMatchingSubLocation) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: true,
              });

              el?.attributes?.subLocations?.data?.length > 0 &&
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (allIds.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
            }
          }
        } else {
          parentOptions.push({
            key: el.id,
            value: el.id,
            disabled: false,
            text: el.attributes.name,
            image: { src: location_icon },
            className: "main-location-dropdown-option",
          });

          if (el?.attributes?.subLocations?.data?.length > 0) {
            el.attributes.subLocations.data.forEach((subEl) => {
              subOptions.push({
                key: subEl.id,
                value: subEl.id,
                text: subEl.attributes.name,
                image: { src: sub_location_icon },
                className: "sub-location-dropdown-option",
                parentId: el.id,
              });
            });
          }
        }
      });
      subOptions.sort((a, b) => a.text.localeCompare(b.text));

      parentOptions.forEach((parentOption) => {
        the_options.push(parentOption);
        all_options.push(parentOption);

        subOptions.forEach((subOption) => {
          if (subOption.parentId === parentOption.key) {
            the_options.push(subOption);
            all_options.push(subOption);
          }
        });
      });

      let locationsData =
        targetedData?.locations.length > 0
          ? targetedData?.locations?.map((loc) => loc.id)
          : [];

      let result = [];
      let removedIds = [];

      locationsData?.length > 0 &&
        locationsData.forEach((id) => {
          const option = all_options.find((o) => o.key == id);

          if (option) {
            if (option.parentId) {
              const parentOption = all_options.find(
                (o) => o.key == option.parentId && o.disabled === false
              );

              if (locationsData?.includes(parentOption?.key)) {
                result.push(parentOption.id);

                all_options = all_options.filter((o) => o.key != id);
                removedIds.push(id);
              } else {
                result.push(id);
              }
            } else {
              result.push(id);
            }
          }
        });

      let finalResult = result.filter((result) => result !== undefined);
      setData((prev) => {
        return {
          ...prev,
          locations: [...new Set(finalResult)],
        };
      });

      setFetchingLocations(false);
    }

    let jobTitle_options = [];
    if (jobTitle.response) {
      jobTitle_options = jobTitle.response.map((el) => {
        return {
          key: el.id,
          value: el.id,
          text: el.attributes.title,
        };
      });

      setFetchingJobTitle(false);
    }

    let countries_options = [];
    if (countries) {
      countries_options = countries.map((el) => {
        return {
          key: el?.isoCode?.toLowerCase(),
          value: el?.isoCode,
          text: el.name,
          flag: el?.isoCode?.toLowerCase(),
        };
      });
      setFetchingCountries(false);
    }

    setOptions({
      ...options,
      teams: teams.response?.length > 0 ? teams_options : [],
      users: users.data?.length > 0 ? users_options : [],
      locations:
        locations?.response?.length > 0
          ? {
              initOptions: the_options,
              options: all_options,
            }
          : {
              initOptions: [],
              options: [],
            },

      nationalities: countries?.length > 0 ? countries_options : [],
      jobTitle: jobTitle?.response.length > 0 ? jobTitle_options : [],
    });
  };
  const onFileChange = (files, name) => {
    setInitChange(true);
    var randomnumber = Math.floor(Math.random() * (0 - 100 + 1)) + 100;

    if (name == "personalPicture") {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImageSrc(reader.result);
      });
      reader.readAsDataURL(files[0]);

      setFile({
        name: files[0]?.name,
        type: files[0]?.type,
      });
    } else {
      setAttachments({
        ...attachments,
        [name]: {
          file: files[0],
          id: randomnumber,
          name: files[0].name,
          type: files[0].type,
          cancelPopup: false,
          isChanged: true,
        },
      });
    }
  };
  const onCertificateFileChange = (files, name) => {
    setInitChange(true);
    let newFiles = [];
    Array.from(files).forEach((file) => {
      var randomnumber = Math.floor(Math.random() * (0 - 100 + 1)) + 100;
      newFiles.push({
        file: file,
        id: randomnumber,
        name: file.name,
        type: file.type,
        cancelPopup: false,
        isChanged: true,
      });
    });
    setAttachments({
      ...attachments,
      [name]: [...attachments[name], ...newFiles],
    });
  };

  const onValuesChange = (name) => (event, value) => {
    setInitChange(true);
    const boolean_fields = ["hasWorkPermit"];
    const dropdown_fields = [
      "locations",
      "martialStatus",
      "educationLevel",
      "countryCode",
      "emergencyCountryCode",
      "nationality",
      "gender",
      "supervisor",
      "role",
      "cob",
    ];

    if (!boolean_fields.includes(name) || !dropdown_fields.includes(name))
      setData({
        ...data,
        [name]: event.target.value,
      });

    if (boolean_fields.includes(name)) {
      setData({
        ...data,
        [name]: value.checked,
      });
    }

    if (dropdown_fields.includes(name)) {
      setData({
        ...data,
        [name]: value.value,
      });
    }
  };

  const uploadFilessHandler = async (files = []) => {
    let theFiles = files.filter((el) => el.isChanged);
    theFiles = theFiles.map((el) => el.file);
    if (theFiles.length > 0) {
      let reponse = await uploadFile(theFiles);
      return reponse;
    } else {
      return false;
    }
  };

  const updateUserHandler = async (data) => {
    try {
      setButtonStatus(1);
      const contractCopyResponse =
        attachments.contractCopy && attachments.contractCopy.isChanged
          ? await uploadFile([attachments.contractCopy.file])
          : null;

      const passportCopyResponse =
        attachments.passportCopy && attachments.passportCopy.isChanged
          ? await uploadFile([attachments.passportCopy.file])
          : null;
      const idFrontCopyResponse =
        attachments.idCopyFront && attachments.idCopyFront.isChanged
          ? await uploadFile([attachments.idCopyFront.file])
          : null;

      const visaCopyResponse =
        attachments.visaCopy && attachments.visaCopy.isChanged
          ? await uploadFile([attachments.visaCopy.file])
          : null;
      const covidCopyResponse =
        attachments.covidCopy && attachments.covidCopy.length
          ? await uploadFilessHandler(attachments.covidCopy)
          : null;

      let theAttachments =
        covidCopyResponse?.status == 200
          ? covidCopyResponse.data.map((el) => el.id)
          : [];
      let unchangedAttachments = attachments.covidCopy.filter(
        (el) => !el.isChanged
      );
      unchangedAttachments =
        unchangedAttachments.length > 0
          ? unchangedAttachments.map((el) => el.id)
          : [];
      const toBeSendedCertificateFiles = theAttachments.concat(
        unchangedAttachments
      );

      const response = await updateUser(
        data.userId,
        data.role,
        data.firstName.trim() + " " + data.lastName.trim(),
        data.email ? data.email : null,
        data.teams ? data.teams : null,
        data.firstName.trim(),
        data.lastName.trim(),
        data.role == 8 || data.role == 9 ? data?.supervisor || null : null,
        data.selectedLocation ? data.selectedLocation : null,
        data.phone ? data.phone : null,
        personalImgId,
        organisationId,
        {
          id: data.profileId,
          phone: data.phone ? data.phone : null,
          address: data.address ? String(data.address) : null,
          emergencyName: data.emergencyName ? String(data.emergencyName) : null,
          emergencyPhone: data.emergencyPhone ? data.emergencyPhone : null,
          educationLevel: String(data.educationLevel) || null,
          fieldOfStudy: String(data.fieldOfStudy) || null,
          martialStatus: String(data.martialStatus) || null,
          nationality: String(data.nationality) || null,
          passportNo: String(data.passportNo) || null,
          identificationNo: String(data.identificationNo) || null,
          dob: data.dob ? format(new Date(data.dob), "yyyy-MM-dd") : null,
          cob: data.cob ? String(data.cob) : null,
          gender: data.gender ? String(data.gender) : null,
          childrenNo: Number(data.childrenNo) || null,
          visaNo: data.visaNo ? String(data.visaNo) : null,
          visaExpireDate: data.visaExpireDate
            ? format(new Date(data.visaExpireDate), "yyyy-MM-dd")
            : null,
          job: Number(data.jobTitle) || null,
          department: data?.department ? String(data.department) : null,
          hourRate: Number(data.hourRate) || null,
          whpd: Number(data.whpd) || null,
          whpw: Number(data.whpw) || null,
          contractStart: data.contractStart
            ? format(new Date(data.contractStart), "yyyy-MM-dd")
            : null,
          contractEnd: data.contractEnd
            ? format(new Date(data.contractEnd), "yyyy-MM-dd")
            : null,
          registrationNo: Number(data.registrationNo) || null,
          badgeId: String(data.badgeId) || null,
          shifts: data?.shifts || null,
          workPermitNo: data?.workPermitNo ? String(data.workPermitNo) : null,
          days: data.days ? data.days : null,
          contractCopy:
            contractCopyResponse?.status == 200
              ? contractCopyResponse.data[0].id
              : attachments?.contractCopy?.id
              ? attachments.contractCopy.id
              : null,
          idCopyFront:
            idFrontCopyResponse?.status == 200
              ? idFrontCopyResponse.data[0].id
              : attachments?.idCopyFront?.id
              ? attachments.idCopyFront.id
              : null,
          personalPicture: personalImgId ? personalImgId : null,
          passportCopy:
            passportCopyResponse?.status == 200
              ? passportCopyResponse.data[0].id
              : attachments?.passportCopy?.id
              ? attachments.passportCopy.id
              : null,
          visaCopy:
            visaCopyResponse?.status == 200
              ? visaCopyResponse.data[0].id
              : attachments?.visaCopy?.id
              ? attachments.visaCopy.id
              : null,
          covidCopy: toBeSendedCertificateFiles,
        }
      );

      if (response.status == 200) {
        setResponseData({
          id: response.data.id,
          name: response.data.firstName,
        });

        setButtonStatus(0);
        cancelHandler();
        setSortData([]);
        setFilterOptions({
          role: [],
          supervisors: [],
          jobTitle: [],
          teams: [],
          status: [],

          rate: {
            from: null,
            to: null,
          },
        });
        setSearchTitle("");

        toast.success(t.people.title + " " + t.common.updated_success);
      }

      setButtonStatus(0);
    } catch (err) {
      if (
        err.message == "This email is already exists" ||
        err.message == "This phone number and email already exist" ||
        err.message == "This phone is already exists"
      ) {
        toast.error(
          t.people.form_validation_errors[err.message] || err.message
        );
      } else {
        toast.error(err.message);
      }
      setButtonStatus(0);
    }
  };

  const updateUserProfileHandler = async (
    id,
    contractCopy,
    personalPicture,
    passportCopy,
    idCopyFront,
    visaCopy,
    covidCopy,
    data
  ) => {
    const response = await updateUserProfile(
      id,
      data.phone ? data.phone : null,
      data.address ? String(data.address) : null,
      data.emergencyName ? String(data.emergencyName) : null,
      data.emergencyPhone ? data.emergencyPhone : null,
      String(data.educationLevel) || null,
      String(data.fieldOfStudy) || null,
      String(data.martialStatus) || null,
      String(data.nationality) || null,
      String(data.passportNo) || null,
      String(data.identificationNo) || null,
      data.dob ? format(new Date(data.dob), "yyyy-MM-dd") : null,
      data.cob ? String(data.cob) : null,
      data.gender ? String(data.gender) : null,
      Number(data.childrenNo) || null,
      String(data.visaNo) || null,
      data.visaExpireDate
        ? format(new Date(data.visaExpireDate), "yyyy-MM-dd")
        : null,
      Number(data.jobTitle) || null,
      String(data.department) || null,
      Number(data.hourRate) || null,
      Number(data.whpd) || null,
      Number(data.whpw) || null,
      data.contractStart
        ? format(new Date(data.contractStart), "yyyy-MM-dd")
        : null,
      data.contractEnd
        ? format(new Date(data.contractEnd), "yyyy-MM-dd")
        : null,
      Number(data.registrationNo) || null,
      String(data.badgeId) || null,
      data.shifts || null,
      String(data.workPermitNo) || null,
      data.days ? data.days : null,
      contractCopy,
      idCopyFront,
      personalPicture,
      passportCopy,
      visaCopy,
      covidCopy
    );

    if (response.status == 200) {
      setButtonStatus(0);
      cancelHandler();
      setSortData([]);
      setFilterOptions({
        role: [],
        supervisors: [],
        jobTitle: [],
        teams: [],
        status: [],

        rate: {
          from: null,
          to: null,
        },
      });
      setSearchTitle("");

      toast.success(t.people.title + " " + t.common.updated_success);
    }
  };

  const cancelHandler = () => {
    resetForm();
    toggleCancelModal(false);
    setModalWidth(Math.max(window.innerWidth / 2, 514));
    setNewCancelModal(false);
    activateLoading(false);
    setInitChange(false);
    untoggle();
  };
  const changeTab = async (tab, errors, setFieldTouched, values) => {
    let errorFields = Object.keys(errors);
    let hasError = false;
    if (activePane > tab) {
      setActivePane(tab);
      return;
    }
    if (tab == 1) {
      if (errorFields && errorFields.length) {
        for (let i = 0; i < firstTabValidationFields.length; i++) {
          if (errorFields.includes(firstTabValidationFields[i])) {
            hasError = true;
            setFieldTouched(firstTabValidationFields[i], true);
          }
        }
      }

      if (!hasError) {
        let validateEmailAndPhone = await verifyPersonEmailAndPhone(
          values.userId || null,
          values.email ? values.email : null,
          values.phone,
          organisationId,
          values.role
        );
        if (validateEmailAndPhone && validateEmailAndPhone.status != 200) {
          hasError = true;
          toast.error(
            t.people.form_validation_errors[validateEmailAndPhone.error] ||
              validateEmailAndPhone.error
          );
        }
      }
    } else if (tab == 2) {
      if (errorFields && errorFields.length) {
        for (let i = 0; i < firstTabValidationFields.length; i++) {
          if (errorFields.includes(firstTabValidationFields[i])) {
            hasError = true;
            setFieldTouched(firstTabValidationFields[i], true);
          }
        }
      }

      if (!hasError) {
        let validateEmailAndPhone = await verifyPersonEmailAndPhone(
          values.userId || null,
          values.email ? values.email : null,
          values.phone,
          organisationId,
          values.role
        );
        if (validateEmailAndPhone && validateEmailAndPhone.status != 200) {
          hasError = true;
          toast.error(
            t.people.form_validation_errors[validateEmailAndPhone.error] ||
              validateEmailAndPhone.error
          );
        }
      }
      if (errorFields && errorFields.length) {
        for (let i = 0; i < firstTabValidationFields.length; i++) {
          if (errorFields.includes(firstTabValidationFields[i])) {
            hasError = true;
            setFieldTouched(firstTabValidationFields[i], true);
          }
        }
      }
      for (let i = 0; i < firstTabValidationFields.length; i++) {
        if (errorFields.includes(firstTabValidationFields[i])) {
          hasError = true;
          setFieldTouched(firstTabValidationFields[i], true);
        }
      }
    }
    if (!hasError) {
      setActivePane(tab);
    }
  };

  const fetchLocations = async () => {
    const fetchData = await getAllParentLocations(
      organisationId,
      "",
      1,
      99999,
      [],
      [],
      [],
      ["name:asc"]
    );
    let the_options = [];
    let parentOptions = [];
    let subOptions = [];
    if (fetchData?.response?.length > 0) {
      fetchData.response.forEach((el) => {
        if (!(roleData === "super_admin")) {
          if (allIds?.includes(el.id)) {
            parentOptions.push({
              key: el.id,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
              disabled: false,
            });

            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                if (allIds?.includes(subEl.id)) {
                  subOptions.push({
                    key: subEl.id,
                    value: subEl.id,
                    text: subEl.attributes.name,
                    image: { src: sub_location_icon },
                    className: "sub-location-dropdown-option",
                    parentId: el.id,
                  });
                }
              });
            }
          } else {
            const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
              (subEl) => allIds?.includes(subEl.id)
            );

            if (hasMatchingSubLocation) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: true,
              });

              el?.attributes?.subLocations?.data?.length > 0 &&
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (allIds?.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
            }
          }
        } else {
          parentOptions.push({
            key: el.id,
            value: el.id,
            text: el.attributes.name,
            image: { src: location_icon },
            disabled: false,
            className: "main-location-dropdown-option",
          });

          if (el?.attributes?.subLocations?.data?.length > 0) {
            el.attributes.subLocations.data.forEach((subEl) => {
              subOptions.push({
                key: subEl.id,
                value: subEl.id,
                text: subEl.attributes.name,
                image: { src: sub_location_icon },
                className: "sub-location-dropdown-option",
                parentId: el.id,
              });
            });
          }
        }
      });

      subOptions.sort((a, b) => a.text.localeCompare(b.text));

      parentOptions.forEach((parentOption) => {
        the_options.push(parentOption);

        subOptions.forEach((subOption) => {
          if (subOption.parentId === parentOption.key) {
            the_options.push(subOption);
          }
        });
      });

      // Update the options state
      setOptions((prev) => ({
        ...prev,
        locations: {
          options: the_options,
          initOptions: the_options,
        },
      }));

      return the_options;
    }
  };

  const fetchCountries = () => {
    const fetchData = Country.getAllCountries();
    let the_options = [];
    if (fetchData) {
      the_options = fetchData.map((el) => {
        return {
          key: el?.isoCode?.toLowerCase(),
          value: el.isoCode,
          text: el.name,
          flag: el?.isoCode?.toLowerCase(),
        };
      });

      setOptions({ ...options, nationalities: the_options });
    }
  };

  const fetchTeamsData = async () => {
    const fetchData = await getAllTeams(
      organisationId,
      "",
      1,
      99999,
      [],
      [],
      [],
      []
    );

    if (fetchData.response) {
      let the_options = fetchData.response.map((el) => {
        const the_image = LetteredAvatarImageUrl(el.attributes.name);
        return {
          key: el.id,
          value: el.id,
          text: el.attributes.name,
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });
      setOptions({
        ...options,
        teams: the_options,
      });
    }
  };

  const fetchJobTitleData = async () => {
    const fetchData = await getAllJobTitles(organisationId);

    if (fetchData.response) {
      let the_options = fetchData.response.map((el) => {
        return {
          key: el.id,

          value: el.id,
          text: el.attributes.title,
        };
      });

      setOptions({
        ...options,
        jobTitle: the_options,
      });

      return the_options;
    }
  };

  return (
    <>
      <div
        clearing
        style={{ maxWidth: `${modalWidth}px` }}
        className={
          toggled ? "aside-modal active procedure" : "aside-modal procedure"
        }
      >
        <Resizable
          size={{ width: modalWidth, height: "auto" }}
          minWidth={"514px"}
          onResize={(e, direction, ref, d) => {
            setModalWidth(ref.offsetWidth);
          }}
        >
          <div className="modal-header">
            <div className="flexbox justify-between">
              <div className="name">
                {t.people.personal_info_form_edit.edit_person} #
                {targetedData?.countId}
              </div>
              <div>
                <span
                  className="c-pointer position-relative text-right"
                  onMouseOver={() => setCancleTooltip(true)}
                  onMouseLeave={() => setCancleTooltip(false)}
                  onClick={() =>
                    initChange ? setNewCancelModal(true) : cancelHandler()
                  }
                >
                  <CloseIcon />
                  <ToolTip
                    color="#fff"
                    backgroundColor="#172B4D"
                    position={
                      selectedLanguage == "en"
                        ? "bottom center"
                        : "bottom center"
                    }
                    arrowAlign="center"
                    show={showCancleTooltip}
                    textBoxWidth="36px"
                    padding="5px 5px 5px 7px"
                    borderRadius="5px"
                    static
                  >
                    <span className="work-order-preview-tooltip">
                      {t.common.close}
                    </span>
                  </ToolTip>
                </span>
              </div>
            </div>
          </div>

          <PeopleForm
            setData={setData}
            setFile={setFile}
            file={file}
            setImageSrc={setImageSrc}
            imageSrc={imageSrc}
            setDropdownOptions={setOptions}
            PersonLimitedValidationSchema={PersonLimitedValidationSchema}
            setPersonalImgId={setPersonalImgId}
            data={data}
            userProfileLoc={allIds}
            PersonValidationSchema={PersonValidationSchema}
            PersonTechnicianValidationSchema={PersonTechnicianValidationSchema}
            organisationId={organisationId}
            PersonRequesterValidationSchema={PersonRequesterValidationSchema}
            handleSubmit={updateUserHandler}
            activePane={activePane}
            changeTab={changeTab}
            dropdownOptions={options}
            fetchCountries={fetchCountries}
            fetchJobTitleData={fetchJobTitleData}
            fetchLocations={fetchLocations}
            cancelHandler={cancelHandler}
            toggleCancelModal={toggleCancelModal}
            setNewCancelModal={setNewCancelModal}
            onFileChange={onFileChange}
            initChange={initChange}
            buttonStatus={buttonStatus}
            attachments={attachments}
            setAttachments={setAttachments}
            onCertificateFileChange={onCertificateFileChange}
            edit={true}
          />
        </Resizable>
      </div>

      <div
        className={
          toggled ? "aside-modal-background active" : "aside-modal-background"
        }
        onClick={() => (initChange ? setNewCancelModal(true) : cancelHandler())}
      ></div>

      <NewCancelModal
        yesCallback={() => {
          cancelHandler();
        }}
        title={t.parts.form.changes}
      >
        <p className="cancel-child"> {t.common.cancel_2statement}</p>
      </NewCancelModal>
    </>
  );
}

export default Edit;
